import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import AdminLayout from './components/AdminLayout';
import SuperAdminRoute from './components/SuperAdminRoute';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import AcceptInvite from './pages/AcceptInvite';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Clinics from './pages/Clinics';
import ClinicDetail from './pages/ClinicDetail';
import Clinicians from './pages/Clinicians';
import ClinicianDetail from './pages/ClinicianDetail';
import Settings from './pages/Settings';
import AdminUsers from './pages/admin/AdminUsers';
import AdminUserDetail from './pages/admin/AdminUserDetail';
import AdminClinics from './pages/admin/AdminClinics';
import AdminClinicians from './pages/admin/AdminClinicians';
import AdminClinicDetail from './pages/admin/AdminClinicDetail';
import AdminClinicianDetail from './pages/admin/AdminClinicianDetail';
import AdminGlobalSettings from './pages/admin/AdminGlobalSettings';
import ChoosePlan from './pages/ChoosePlan';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/invite/accept" element={<AcceptInvite />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/choose-plan" element={
            <ProtectedRoute>
              <ChoosePlan />
            </ProtectedRoute>
          } />
          <Route element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route path="/" element={<Dashboard />} />
            <Route path="/clinics" element={<Clinics />} />
            <Route path="/clinics/:clinicId" element={<ClinicDetail />} />
            <Route path="/clinicians" element={<Clinicians />} />
            <Route path="/clinicians/:clinicianId" element={<ClinicianDetail />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
          <Route element={
            <ProtectedRoute>
              <SuperAdminRoute>
                <AdminLayout />
              </SuperAdminRoute>
            </ProtectedRoute>
          }>
            <Route path="/admin" element={<Navigate to="/admin/users" replace />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/users/:userId" element={<AdminUserDetail />} />
            <Route path="/admin/clinics" element={<AdminClinics />} />
            <Route path="/admin/clinics/:clinicId" element={<AdminClinicDetail />} />
            <Route path="/admin/clinicians" element={<AdminClinicians />} />
            <Route path="/admin/clinicians/:clinicianId" element={<AdminClinicianDetail />} />
            <Route path="/admin/settings" element={<AdminGlobalSettings />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
